import { Tab, Tabs, Icon, List, Dialog, Popup, DatePicker, Field, Loading, Image as VanImage } from 'vant';
import { createApp, onMounted, defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { get } from '../../api/utils/request.ts';
export default defineComponent({
  props: {
    uid: {
      type: String
    }
  },
  components: {},
  setup() {},
  data() {
    return {
      active: 2,
      Name: '',
      ContactNumber: '',
      Gender: '',
      Birthday: '',
      Email: '',
      Location: '',
      TaxNumber: '',
      CustomerNO: '',
      CustomerName: '',
      InterestList1: ref([]),
      InterestList2: ref([]),
      isrequest: 0,
      sci: ''
    };
  },
  created() {},
  mounted() {
    console.log("mounted");
    const router = useRouter();
    var param = router.currentRoute.value.query;
    var sci = param.sci;
    this.sci = sci;
    this.GetUserData(sci == 'system' ? 'U98a43ed49befca0b4631067e3262e114' : sci);
  },
  methods: {
    TabChage(url) {
      this.$router.replace({
        path: url,
        query: {
          sci: this.sci
        }
      });
    },
    //用户信息
    GetUserData(sci) {
      // const  sci= localStorage.getItem('sci');
      // sci == ''?'U98a43ed49befca0b4631067e3262e114':sci
      get('/api/services/app/LineService/GetCustomerInfo', {
        sci: sci,
        soi: 'bPnwy8GUNj'
      }).then(res => {
        console.log(res);
        this.isrequest = 1;
        if (res.result.code == 1) {
          this.Name = res.result.data.name;
          this.ContactNumber = res.result.data.contactNumber;
          this.Gender = res.result.data.gender;
          this.Birthday = res.result.data.birthday;
          this.TaxNumber = res.result.data.taxNumber;
          this.Email = res.result.data.email;
          this.Location = res.result.data.location;
          this.CustomerNO = res.result.data.customerNO;
          this.CustomerName = res.result.data.customerName;
          this.InterestList1 = res.result.data.interestList1;
          this.InterestList2 = res.result.data.interestList2;
        } else {
          // this.isrequest=1
        }
      });
    }
  }
});